/**
 * 百度统计 + 爱番番在线客服脚本
 * 开发/测试环境默认不加载，避免客服浮窗干扰联调；生产环境正常加载
 * 可通过 VITE_ENABLE_BAIDU_STAT=true 强制开启（例如需要在测试环境验证客服功能时）
 */
export function loadBaiduStat() {
  const enabled = import.meta.env.VITE_ENABLE_BAIDU_STAT === 'true' || import.meta.env.MODE === 'production';
  if (!enabled) return;

  (window as any)._hmt = (window as any)._hmt || [];
  const hm = document.createElement('script');
  hm.src = 'https://hm.baidu.com/hm.js?8142737e802bb23e958cc8b647a717b5';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode?.insertBefore(hm, s);
}
